<ng-select
  [formControl]="reactiveControl"
  [clearable]="isClearable"
  [closeOnSelect]="!isMultiple"
  [labelForId]="inputId"
  [placeholder]="placeholder"
  [items]="data"
  [markFirst]="true"
  [multiple]="isMultiple"
  [bindLabel]="displayProperty[0]"
  [bindValue]="valueProperty"
  [searchable]="isSearchable"
  (add)="onAdd($event)"
  (change)="onChange($event)"
  (remove)="onRemove($event)"
  *ngIf="reactiveControl"
  #select
>
  <ng-template ng-loadingspinner-tmp>
    <app-spinner class="me-2"></app-spinner>
  </ng-template>

  <ng-template ng-header-tmp>
    <small class="form-text block border-b px-2 text-muted">
      <ng-container *ngIf="data?.length" i18n>Wczytano {{ data.length }} elementów.</ng-container>
    </small>
  </ng-template>

  <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
    <small class="form-text px-2 text-muted" i18n>Brak wyników.</small>
  </ng-template>

  <ng-template ng-label-tmp let-item="item" let-clear="clear">
    <span
      class="relative block z-10 overflow-hidden text-ellipsis"
      #valueLabel
      [ngbTooltip]="getLabel(item[displayProperty[0]], item[displayProperty[1]])"
      [disableTooltip]="isTooltipDisabled(valueLabel) | async"
    >
      {{ getLabel(item[displayProperty[0]], item[displayProperty[1]]) }}
    </span>
    <button
      ndt-icon-button
      type="button"
      class="h-4 w-4 p-0"
      aria-label="Usuń element"
      i18n-aria-label
      (click)="clear(item)"
      (mousedown)="$event.stopPropagation()"
      *ngIf="isMultiple"
    >
      <app-icon name="close"></app-icon>
    </button>
  </ng-template>

  <ng-template ng-option-tmp let-item="item" let-index="index" let-item$="item$">
    <div *ngIf="isMultiple; else single" class="form-check">
      <input
        type="checkbox"
        [attr.aria-labelledby]="'item-' + index"
        class="form-check-input"
        [ngModel]="item$.selected"
      />
      <label
        #optionLabel
        id="item-{{ index }}"
        class="form-check-label"
        [ngbTooltip]="getLabel(item[displayProperty[0]], item[displayProperty[1]])"
        [disableTooltip]="isTooltipDisabled(optionLabel) | async"
        [positionTarget]="optionLabel.parentElement"
      >
        {{ getLabel(item[displayProperty[0]], item[displayProperty[1]]) }}
      </label>
    </div>
    <ng-template #single>
      <span
        #optionLabel
        [ngbTooltip]="getLabel(item[displayProperty[0]], item[displayProperty[1]])"
        [disableTooltip]="isTooltipDisabled(optionLabel) | async"
        [positionTarget]="optionLabel.parentElement"
      >
        {{ getLabel(item[displayProperty[0]], item[displayProperty[1]]) }}
      </span>
    </ng-template>

    <ng-template #optionDescriptions>
      <span
        *ngFor="let templatex of templates; let i = index"
        class="after:content-['|'] after:inline-block last:after:hidden"
      >
        <span class="ml-2 mr-2" [ngClass]="{ 'ml-0': i === 0 }">
          <ng-container *ngTemplateOutlet="templatex; context: item"></ng-container>
        </span>
      </span>
    </ng-template>

    <ng-template #optionDescriptionTooltip>
      <div>
        <ng-container *ngTemplateOutlet="optionDescriptions"></ng-container>
      </div>
    </ng-template>

    <small
      class="option-description block text-sm"
      [ngbTooltip]="optionDescriptionTooltip"
      [disableTooltip]="isTooltipDisabled(optionDescriptionsContainer) | async"
      *ngIf="templates"
    >
      <span #optionDescriptionsContainer class="overflow-hidden text-ellipsis block">
        <ng-container *ngTemplateOutlet="optionDescriptions"></ng-container>
      </span>
    </small>
  </ng-template>
</ng-select>
